import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
//--------------------------------------------------------------------------------------------
import magnifierImg from "src/img/magnifier.png";
import Resize from "src/components/common/resize";
import Footer from "src/components/common/frame/footer";
import { useMyStore } from "src/components/main/mainStore";
import {
    boolAndReducer, myAxios, objDescSort, getTimeStamp,
    appTitle
} from "src/components/common/functions";
import FilterForm from "./filter";
import Export from "./export";
//--------------------------------------------------------------------------------------------
export default function RentalStatus({ tabTitle }){
    const user = useMyStore(state => state.user);
    //------------------------------------------------------
    const [updateDateTime, setUpdateDateTime] = useState(getTimeStamp());
    const [filterWords, setFilterWords] = useState("");
    const defaultFilter = {
        projectName: "", 
        laborCategory: "",
        laborName: "",
        department: "",
        workLogSubmitTimeMin: "",
        workLogSubmitTimeMax: "",
    };
    const [curFilter, setFilter] = useState(defaultFilter);
    const [showFilter, setShowFilterForm] = useState(false);
    //------------------------------------------------------
    const [currentData, setCurrentData] = useState([]);
    const [showLoading, setShowLoading] = useState(true);
    const [projectMap, setProjectMap] = useState({});
    const [currentPage, setCurrentPage] = useState(1);
    const [itemsPerPage, setItemsPerPage] = useState(10);
    //--------------------------------------------------------------------------------------------
    const indexOfLastProject = currentPage * itemsPerPage;
    const indexOfFirstProject = indexOfLastProject - itemsPerPage;
    const filterData = currentData.filter(u => 
        (curFilter.projectName?u.projectName === curFilter.projectName:true)
        && (curFilter.laborName?u.laborName === curFilter.laborName:true)
        && (curFilter.laborCategory?u.laborCategory === curFilter.laborCategory:true)
        && (curFilter.department?u.department === curFilter.department:true)
        && (curFilter.workLogSubmitTimeMin?u.workLogSubmitTime >= curFilter.workLogSubmitTimeMin:true)
        && (curFilter.workLogSubmitTimeMax?u.workLogSubmitTime <= curFilter.workLogSubmitTimeMax:true)
        && (curFilter.startMin?u.startTime >= curFilter.startMin:true)
        && (curFilter.startMax?u.startTime <= curFilter.startMax:true)
        && (curFilter.endMin?u.endTime >= curFilter.endMin:true)
        && (curFilter.endMax?u.endTime <= curFilter.endMax:true)
        && (filterWords.toLowerCase().split(" ").map(f => JSON.stringify(
            Object.values(u)
        ).toLowerCase().indexOf(f) > -1).reduce(boolAndReducer, true))
    );

    const currentPageProjects = filterData.slice(indexOfFirstProject, indexOfLastProject);
    const pageNumbers = Array.from({length: Math.ceil(filterData.length / itemsPerPage)}, (_, i) => (i + 1));
    //--------------------------------------------------------------------------------------------
    useEffect(() => {
        let isMounted = true;
        const getData = async () => {
            //------------------------------------------------------------
            setShowLoading(true);
            const res = await myAxios("approvals/readRentalStatus.php");
            if(!isMounted) return;
            setShowLoading(false);
            if(!res) return;
            //------------------------------------------------------------
            const data = res.data;
            const forms = data.forms.map((d => ({
                ...d, 
                laborName: d.laborName.replace(/ {2}/g, " "),
                ...JSON.parse(d.formContent || "{}")
            })));
            const projectsMap = Object.fromEntries(res.data.projects.map(p => [p.projectHashKey, p.projectName]));
            setProjectMap(projectsMap);
            const returnForms = forms.filter(d => d.formType === "Return Form");
            const returnFormsMap =  Object.fromEntries(returnForms.map(p => [p["rentalFormHashKey"], p]));
            const rentalForms = forms.filter(d => d.formType === "Rental Form").map(d => ({
                ...d,
                returnForm: returnFormsMap[d.formHashKey] //undefined if no return form
            }));
            setCurrentData(rentalForms.sort((a, b) => objDescSort(a, b, "dateSubmitted")));
        }
        getData();
        return () => {isMounted = false;}
    }, [updateDateTime])
    useEffect(() => {
        document.title = tabTitle;
        return () => {
            document.title = appTitle;
        };
    }, [tabTitle]);
    //--------------------------------------------------------------------------------------------
    return(
            <div className = "cssTab">
            <div  className = "cssHeader" style = {{background: user.userTheme}}>
                <span>
                    <Resize/>
                    Rental Status
                    <span data-toggle = "tooltip" title = {"Refreshed on " + updateDateTime} className = "btn btn-primary py-1 ml-4" onClick = {() => setUpdateDateTime(getTimeStamp())}>↻</span>
                </span>
                <span>
                    <input
                        className = "form-control w-auto"
                        type = "text"
                        value = {filterWords}
                        onChange = {e => {
                            setFilterWords(e.currentTarget.value.toLowerCase());
                            setCurrentPage(1);
                        }}
                    />
                    <img alt = "" src = {magnifierImg}/>
                </span>
                <span className = "pointer rounded p-1" style = {{
                    backgroundColor: Object.entries(curFilter).filter(([key, value]) => defaultFilter[key] !== value).length?
                    "rgb(0,123,255)"
                    :null
                }} onClick = {() => {setShowFilterForm(true)}}>
                    Filter
                </span>
                {showFilter?<FilterForm
                    setCurrentPage = {setCurrentPage}
                    curFilter = {curFilter}
                    setFilter = {setFilter}
                    closeIt = {() => setShowFilterForm(false)}
                    defaultFilter = {defaultFilter}
                    currentData = {currentData}
                />:null}
                <Export
                    filterData = {filterData}
                />
            </div>
            <div className = "cssContent pb10">
                {showLoading?<div className = "cssLoading">Loading...</div>:
                !filterData.length?<div className = "cssLoading">Empty</div>:
                <div className = "table-responsive">
                    <table className = "table">
                        <thead className = "noTableTopBorder">
                            <tr>
                                <th>Equipment</th>
                                <th>Project Name</th>
                                <th>Technician</th>
                                <th>Department</th>
                                <th>Start Date</th>
                                <th>Expire Date</th>
                                <th>Returned By</th>
                                <th>Return Date</th>
                            </tr>
                            </thead>
                            <tbody> 
                            {currentPageProjects.map((v, key) =>
                                <tr key = {key}>
                                    <td>
                                        <Link to = {`/Forms/${v.formHashKey}`}>
                                            {v["Equipment Name"]}
                                        </Link>
                                    </td>
                                    <td>
                                        <Link to = {`/Forms/${v.formHashKey}`}>
                                            {projectMap[v.projectHashKey]}
                                        </Link>
                                    </td>
                                    <td>
                                        <Link to = {`/Forms/${v.formHashKey}`}>
                                            {v.laborName}
                                        </Link>
                                    </td>
                                    <td>
                                        <Link to = {`/Forms/${v.formHashKey}`}>
                                            {v.department}
                                        </Link>
                                    </td>
                                    <td>
                                        <Link to = {`/Forms/${v.formHashKey}`}>
                                            {v["Rental Start Date"]}
                                        </Link>
                                    </td>
                                    <td>
                                        <Link to = {`/Forms/${v.formHashKey}`}>
                                            {v["Rental Expire Date"]}
                                        </Link>
                                    </td>
                                    <td>
                                        <Link to = {`/Forms/${v.returnForm?.formHashKey}`}><span className = "text-success">
                                            {v.returnForm?.laborName}
                                        </span></Link>
                                    </td>
                                    <td>
                                        <Link to = {`/Forms/${v.returnForm?.formHashKey}`}><span className = "text-success">
                                            {v.returnForm?.["Rental Return Date"]}
                                        </span></Link>
                                    </td>
                                </tr>
                            )}
                        </tbody>
                    </table>
                </div>}
                {!showLoading && filterData.length?
                <Footer
                    length = {filterData.length}
                    pageNumbers = {pageNumbers}

                    currentPage = {currentPage}
                    setCurrentPage = {setCurrentPage}
                    itemsPerPage = {itemsPerPage}
                    setItemsPerPage = {setItemsPerPage}
                />
                :null}
            </div>
        </div>
    )
}